import React from 'react'
import Footer from '../../Footer'
import fig1 from '../../../img/tech/car/1.png'
import '../Proj.css'


export default class ProjCar extends React.Component{
    render(){
        return(
            <div className="proj-wrapper">
                <div className='proj-wrap-86'>
                    <div id='texel-title'>
                        <h1>EE Course Design: Arduino Autonomous Car</h1>
                    </div>
                    <p className='little-title'>Joined the course design and helped students debug as a teachering assistant of Cornerstone EECS Design and Implementation, taught by Prof. Shih-Yuan Chen</p>
                    <div className='proj-fig1' id='car-fig'>
                        <img src={fig1} />
                    </div>
                    <p>The course's primary purpose is to introduce various basic concepts in the EECS field by implementing an autonomous car. Throughout the semester, first-year students take lectures about
                        <b>microcontrollers, implementing circuits, control systems, algorithms, RFID, etc. </b>
                        Then, they spend more than half semester building a pre-designed autonomous car with the guidance of professors and TAs and compete the speed and accuracy of their car running through a maze.
                    </p>

                    <p>
                    <b>The TAs' responsibility is to help debug and clarify students' concepts related to Arduino, serial communication, and circuit debugging throughout all implementing sections. I was one of the four TAs for a class with 28 students.<br/>
                    <br/>
                    I took part in the course design process by helping to improve the course design regarding the controlling system.</b> 
                    </p>
                    <Footer back={true}/>
                </div>
                
            </div>
        )
    }
}